const HIGHLIGHT_BACKGROUND_COLOR = 'hsl(60, 97%, 73%)';
const VIDEO_HEIGHT = 315;
const OGP_HEIGHT = 160;

// oembed → iframe 変換
const convertOembedElements = (doc) => {
  // 余計な div で figure がラップされていたら剥がす
  doc.querySelectorAll('div > figure.media').forEach((figure) => {
    const parent = figure.parentElement;
    if (parent && parent.tagName === 'DIV') {
      parent.replaceWith(figure);
    }
  });

  doc.querySelectorAll('oembed[url]').forEach((oembed) => {
    const url = oembed.getAttribute('url') || '';
    if (!url) return;

    let iframeSrc = null;
    let height = OGP_HEIGHT;

    try {
      const parsedUrl = new URL(url);
      if (!['http:', 'https:'].includes(parsedUrl.protocol)) return;

      const hostname = parsedUrl.hostname.replace('www.', '');

      // ===== YouTube =====
      if (hostname === 'youtube.com') {
        const shortsMatch = parsedUrl.pathname.match(/\/shorts\/([^/?]+)/);
        if (shortsMatch) {
          iframeSrc = `https://www.youtube.com/embed/${shortsMatch[1]}`;
          height = VIDEO_HEIGHT;
        } else {
          const videoId = parsedUrl.searchParams.get('v');
          if (videoId) {
            iframeSrc = `https://www.youtube.com/embed/${videoId}`;
            height = VIDEO_HEIGHT;
          }
        }
      }

      // ===== youtu.be =====
      if (hostname === 'youtu.be') {
        const idMatch = parsedUrl.pathname.match(/^\/([^/?]+)/);
        if (idMatch) {
          iframeSrc = `https://www.youtube.com/embed/${idMatch[1]}`;
          height = VIDEO_HEIGHT;
        }
      }

      // ===== Vimeo =====
      if (hostname === 'vimeo.com') {
        const match = parsedUrl.pathname.match(/\/(\d+)/);
        if (match) {
          iframeSrc = `https://player.vimeo.com/video/${match[1]}`;
          height = VIDEO_HEIGHT;
        }
      }

      // ===== OGP =====
      if (!iframeSrc) {
        iframeSrc = `/open_graph?url=${encodeURIComponent(url)}`;
        height = OGP_HEIGHT;
      }
    } catch {
      return;
    }

    const isVideo = height === VIDEO_HEIGHT;

    if (isVideo) {
      // 動画の場合
      const wrapper = doc.createElement('div');
      wrapper.className = 'se-component se-video-container __se__float-none';
      wrapper.style.width = '100%';

      const figure = doc.createElement('figure');
      figure.style.width = '100%';
      figure.style.height = `${VIDEO_HEIGHT}px`;

      const iframe = doc.createElement('iframe');
      iframe.src = iframeSrc;
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('data-proportion', 'false');
      iframe.setAttribute('data-percentage', `100%,${VIDEO_HEIGHT}px`);
      iframe.setAttribute('data-size', `100%,${VIDEO_HEIGHT}px`);
      iframe.setAttribute('data-align', 'none');
      iframe.setAttribute('data-file-name', '');
      iframe.setAttribute('data-file-size', '0');
      iframe.setAttribute('data-origin', `100%,${VIDEO_HEIGHT}px`);
      iframe.style.cssText = `border:none; width:100%; height:${VIDEO_HEIGHT}px;`;

      figure.appendChild(iframe);
      wrapper.appendChild(figure);

      const oembedFigure = oembed.closest('figure');
      if (oembedFigure) {
        oembedFigure.replaceWith(wrapper);
      } else {
        oembed.replaceWith(wrapper);
      }
    } else {
      // OGPの場合
      const wrapper = createOgpComponent(doc, url, iframeSrc);

      const oembedFigure = oembed.closest('figure');
      if (oembedFigure) {
        oembedFigure.replaceWith(wrapper);
      } else {
        oembed.replaceWith(wrapper);
      }
    }
  });

  convertLegacyOgpIframes(doc);
};

// OGP の編集用コンポーネント（保存時に init.ts の正規化で oembed へ戻す）
const createOgpComponent = (doc, url, iframeSrc) => {
  const wrapper = doc.createElement('div');
  wrapper.className = 'se-component se-ogp-container __se__float-none';
  wrapper.style.width = '100%';
  wrapper.style.position = 'relative';
  wrapper.style.height = `${OGP_HEIGHT}px`;

  const figure = doc.createElement('figure');
  figure.style.width = '100%';
  figure.style.margin = '0';
  figure.style.height = '100%';

  const iframe = doc.createElement('iframe');
  iframe.src = iframeSrc;
  iframe.setAttribute('width', '100%');
  iframe.setAttribute('height', `${OGP_HEIGHT}`);
  iframe.setAttribute('loading', 'lazy');
  iframe.setAttribute('scrolling', 'no');
  iframe.setAttribute('frameborder', '0');
  iframe.style.cssText = 'border:none; width:100%; height:100%;';

  const anchor = doc.createElement('a');
  anchor.className = 'se-ogp-link-overlay';
  anchor.href = url;
  anchor.target = '_blank';
  anchor.rel = 'noopener noreferrer nofollow';
  anchor.setAttribute('aria-label', `${url} のプレビューを開く`);
  anchor.style.position = 'absolute';
  anchor.style.inset = '0';
  anchor.style.zIndex = '8';

  figure.appendChild(iframe);
  figure.appendChild(anchor);
  wrapper.appendChild(figure);

  return wrapper;
};

// 2026-08-28 以前の編集画面は oembed を `<figure class="media"><iframe src="/open_graph?url=…">`
// （.se-component ラッパーなし）に変換していたが、保存時の正規化は .se-component を目印に
// oembed へ戻すため、この形のまま本文に保存された投稿・テンプレートが残っている。
// そのまま読み込むと表示が崩れ、再保存しても oembed に戻らないので、現行のコンポーネント構造へ変換する
const convertLegacyOgpIframes = (doc) => {
  doc
    .querySelectorAll('iframe[src^="/open_graph?url="]')
    .forEach((iframe) => {
      if (iframe.closest('.se-ogp-container')) return;

      const src = iframe.getAttribute('src') || '';
      const url = extractOgpUrl(src);
      if (!url) return;

      const wrapper = createOgpComponent(doc, url, src);
      const legacyFigure = iframe.closest('figure');
      (legacyFigure || iframe).replaceWith(wrapper);
    });
};

// `/open_graph?url=…` の src から埋め込み元 URL を取り出す
// （不正なエンコードや http/https 以外のスキーム（javascript: 等）は無視する）
const extractOgpUrl = (src) => {
  const match = src.match(/url=([^&]+)/);
  if (!match) return null;

  try {
    const url = decodeURIComponent(match[1]);
    const parsedUrl = new URL(url);
    if (!['http:', 'https:'].includes(parsedUrl.protocol)) return null;

    return url;
  } catch {
    return null;
  }
};

// mark → span に変換
const convertMarkElements = (doc) => {
  doc.querySelectorAll('mark.marker-yellow').forEach((mark) => {
    const span = doc.createElement('span');
    span.style.backgroundColor = HIGHLIGHT_BACKGROUND_COLOR;
    span.innerHTML = mark.innerHTML;
    mark.replaceWith(span);
  });
};

// figure.image を SunEditor の se-image-container 構造に変換
// CKEditor: <figure class="image image_resized">[<a>]<img>[</a>][<figcaption>...</figcaption>]</figure>
// SunEditor: <div class="se-component se-image-container __se__float-none"><figure>[<a>]<img>[</a>]</figure></div>
// SunEditor は figure.image を生成しないため、本変換は実質 CKEditor 由来の HTML を対象とする
// リンクラッパ (<a><img></a>) は SunEditor 自身も画像リンクとして同じ構造を生成するため保持する。
// figcaption は SunEditor のネイティブ画像構造では保持できないため落とす
const convertCkImageFigures = (doc) => {
  doc.querySelectorAll('figure.image').forEach((figure) => {
    const img = figure.querySelector('img');
    if (!img) return;

    const container = doc.createElement('div');
    container.className = 'se-component se-image-container __se__float-none';

    const seFigure = doc.createElement('figure');
    // CKEditor 由来の <figure style="width:50%;..."> 等を引き継ぐ
    // （image_resized クラスでリサイズされた画像が等倍に戻るリグレッション回避）
    const style = figure.getAttribute('style');
    if (style) seFigure.setAttribute('style', style);

    const anchor = img.parentElement;
    seFigure.appendChild(
      anchor && anchor.tagName === 'A' ? anchor.cloneNode(true) : img.cloneNode(true),
    );
    container.appendChild(seFigure);

    figure.replaceWith(container);
  });
};

// CKEditor の <figure class="table"><table>...</table></figure> から figure を剥がして table のみ残す
const unwrapCkTableFigures = (doc) => {
  doc.querySelectorAll('figure.table').forEach((figure) => {
    const table = figure.querySelector(':scope > table');
    if (!table) return;

    figure.replaceWith(table);
  });
};

// CKEditor がリンク前後に挿入する ZWSP (U+200B) をテキストノードから除去
const ZERO_WIDTH_SPACE = '\u200B';

const removeZeroWidthSpaces = (doc) => {
  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, null);

  let node = walker.nextNode();
  while (node) {
    if (node.nodeValue?.includes(ZERO_WIDTH_SPACE)) {
      node.nodeValue = node.nodeValue.replaceAll(ZERO_WIDTH_SPACE, '');
    }
    node = walker.nextNode();
  }
};

// CKEditor 特有の class（js-allow-external-transition 等）を <a> から剥がす
// href / target / rel は SunEditor でも有効なため残す
const stripCkAnchorClasses = (doc) => {
  doc
    .querySelectorAll('a.js-allow-external-transition')
    .forEach((anchor) => {
      anchor.classList.remove('js-allow-external-transition');
      if (anchor.classList.length === 0) {
        anchor.removeAttribute('class');
      }
    });
};

const convertMarkdownToSimpleHtml = (text) => {
  if (!text) return '';

  // HTMLタグが含まれている場合
  if (/<[a-z][\s\S]*>/i.test(text)) return text;

  // 改行で分割してpタグで囲む
  return text
    .split(/\n/)
    .map((line) => {
      if (line.trim() === '') return '<p><br></p>';
      return `<p>${line}</p>`;
    })
    .join('');
};

const convertHtmlToPlainText = (html) => {
  if (!html) return '';

  if (!/<[a-z][\s\S]*>/i.test(html)) return html;

  const doc = new DOMParser().parseFromString(html, 'text/html');

  doc.querySelectorAll('br').forEach((br) => {
    br.replaceWith('\n');
  });

  doc
    .querySelectorAll('p, div, h1, h2, h3, h4, h5, h6, li, tr')
    .forEach((el) => {
      el.insertAdjacentText('afterend', '\n');
    });

  return (doc.body.textContent || '').replace(/\n+$/, '');
};

const transformHtml = (html = '') => {
  if (!html) return '';

  const doc = new DOMParser().parseFromString(html, 'text/html');

  convertOembedElements(doc);
  convertMarkElements(doc);
  convertCkImageFigures(doc);
  unwrapCkTableFigures(doc);
  stripCkAnchorClasses(doc);
  removeZeroWidthSpaces(doc);

  return doc.body.innerHTML;
};

// CKEditorのコンテンツをSunEditor用に変換
const convertCkContents = (id = 'editor') => {
  const textarea = document.getElementById(id);
  if (!textarea) return;

  textarea.value = convertMarkdownToSimpleHtml(textarea.value);
  textarea.value = transformHtml(textarea.value);
};

// HTML文字列を変換
const convertCkHtml = (html) => transformHtml(html);
const convertToEditorHtml = (text) =>
  transformHtml(convertMarkdownToSimpleHtml(text));

export { convertCkHtml, convertHtmlToPlainText, convertToEditorHtml };
export default convertCkContents;
